import { Route, BrowserRouter as Router, Routes } from "react-router-dom"
import Home from "./components/pages/Home"
import Booking from "./components/pages/Booking"
import Navbar from "./components/UI/Header/Navbar"
import Footer from "./components/UI/Footer/Footer"
import { Provider } from "react-redux"
import store from "./components/store/Store"
import { HelmetProvider } from "react-helmet-async"
import GiftCard from "./components/UI/GiftCard/Index"
import { loadStripe } from "@stripe/stripe-js"
import { Elements } from "@stripe/react-stripe-js"
import ViewGiftCard from "./components/UI/GiftCard/ViewGiftCard/Index"
import ViewBookingPub from "./components/UI/BookingView/ViewBookingPub"

// const stripePromise = loadStripe(
//   "pk_test_51OWlUVIIH9KHIiAp3gGjyFGs1gjLabRPBGSwYfV7AEtNLwvpnoNqVSZWTndWjhi7Z573E2c6rJuu4wTvbZbI5Keh00iomaFkc5"
// )
const stripePromise = loadStripe(
  "pk_live_51OWlUVIIH9KHIiApWmPYZxS87AzaR4vKJSZUKImZloOvH2cCMwCxk9lpzEUZ6N4AvErMz4ySSCxZ7mrTpbNtA5Jh00FscZUqJY"
)
function App() {
  return (
    <>
      <HelmetProvider>
        <Provider store={store}>
          <Elements stripe={stripePromise}>
            <div className="bg- black lg:h-screen text-black flex flex-col justify-between">
              <Router>
                <Navbar />
                <Routes>
                  <Route path="/" element={<Home />}></Route>
                  <Route path="/booking" element={<Booking />}></Route>
                  <Route path="/gift-card" element={<GiftCard />}></Route>
                  <Route
                    path="/view-gift-card/:id"
                    element={<ViewGiftCard />}
                  ></Route>
                  <Route
                    path="/view-booking/:id"
                    element={<ViewBookingPub />}
                  ></Route>
                </Routes>
              </Router>
              <Footer />
            </div>
          </Elements>
        </Provider>
      </HelmetProvider>
    </>
  )
}

export default App
